import FIKA from "assets/images/icons/fika-icon.svg";
import TRENT from "assets/images/icons/trent-icon.svg";
import GENERICO from "assets/images/icons/generico-icon.svg";
import SINASIGNAR from "assets/images/icons/sinAsignar-icon.svg";
import FEMMTO from "assets/images/icons/femmto-icon.svg";
import MeliIcon from "assets/images/icons/meli-icon.svg";
import VtexIcon from "assets/images/icons/vtex-icon.svg";
import AmazonIcon from "assets/images/icons/amazon-icon.svg";
import B2bIcon from "assets/images/icons/b2b-icon.svg";
import styled from "@emotion/styled";
import { Switch } from "@mui/material";

export const brandIcons = {
  FIKA: FIKA,
  TRENT: TRENT,
  GENERICO: GENERICO,
  "SIN ASIGNAR": SINASIGNAR,
  FEMMTO: FEMMTO,
};

export const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    "&.Mui-checked": {
      color: "#354887", // color del switch cuando está encendido
      "& + .MuiSwitch-track": {
        backgroundColor: "#9aa3c3", // color del cuerpo cuando está encendido
      },
    },
  },
}));

export const MarketplaceIcons = {
  MELI: MeliIcon,
  VTEX: VtexIcon,
  AMZN: AmazonIcon,
  OFF: B2bIcon,
};

export const COLUMNS_TO_FILTER = [
  { data: "brand", label: "Brand" },
  { data: "kam", label: "KAM" },
  { data: "sku", label: "SKU" },
  { data: "subtype", label: "Subtype" },
  { data: "netsuite_status", label: "Status" },
  { data: "sub_status", label: "Sub-status" },
  { data: "life_cycle", label: "Ciclo de vida" },
  { data: "stock", label: "Stock" },
  { data: "channels", label: "Canales de Venta" },
];

export const INITIAL_COLUMNS_STATE = {
  brand: true,
  kam: true,
  sku: true,
  subtype: true,
  netsuite_status: true,
  sub_status: true,
  life_cycle: true,
  stock: true,
  channels: true,
};
